import React, { FunctionComponent } from "react";
import {
  PivotItem,
  PivotTabs,
  Stack,
  TopBarDefaultHeader
} from "@bps/fluent-ui";
import { UserDetailsForm } from "./details/UserDetailsForm";

import { UserBpId } from "./UserBpId";
import { UserSignInLogs } from "./UserSignInLogs";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SectionTitle } from "@components/SectionTitle";
import {
  ApplicationType,
  PltUser,
  TenantDefaultUsersAuthenticationDto,
  UserDefaultAuthenticationDto,
  UserNetworkAuthenticationSettingsDto
} from "@libs/api/gateways/plt/plt-gateway.dtos";
import { UserSecurity } from "./security/UserSecurity";
import { UserNetworkingSection } from "./networking/UserNetworkingSection";
import { UserAuthForm } from "./auth/UserAuthForm";

enum UserScreenTabs {
  Base = "base",
  BpId = "bp-id",
  Logs = "logs",
  Security = "security",
  Auth = "auth",
  Net = "net"
}

interface UserScreenWrapperProps {
  user: PltUser;
  tenantAuth: TenantDefaultUsersAuthenticationDto | undefined;
  userAuth: UserDefaultAuthenticationDto | undefined;
  application?: ApplicationType;
  networkSettings?: UserNetworkAuthenticationSettingsDto[];
}
export const UserScreenWrapper: FunctionComponent<UserScreenWrapperProps> = props => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const selectedKey =
    (searchParams.get("tab") as UserScreenTabs | null) ?? UserScreenTabs.Base;

  return (
    <Stack tokens={{ childrenGap: 16 }}>
      <TopBarDefaultHeader
        backButtonOnClick={() => navigate(-1)}
        heading="Back"
      />
      <SectionTitle>
        {props.user.firstName} {props.user.lastName}
      </SectionTitle>
      <PivotTabs
        selectedKey={selectedKey}
        onLinkClick={item => {
          const key = item?.props.itemKey as UserScreenTabs;
          const nextParams = new URLSearchParams(searchParams);
          nextParams.set("tab", key);
          setSearchParams(nextParams, { replace: true });
        }}
      >
        <PivotItem itemKey={UserScreenTabs.Base} headerText="Details">
          <UserDetailsForm {...props} />
        </PivotItem>
        <PivotItem itemKey={UserScreenTabs.Auth} headerText="Authentication">
          <UserAuthForm userId={props.user.id} tenantId={props.user.tenantId} />
        </PivotItem>

        <PivotItem itemKey={UserScreenTabs.Net} headerText="Networking">
          <UserNetworkingSection
            userId={props.user.id}
            tenantId={props.user.tenantId}
          />
        </PivotItem>

        <PivotItem itemKey={UserScreenTabs.BpId} headerText="Bp Id">
          <UserBpId user={props.user} />
        </PivotItem>

        <PivotItem itemKey={UserScreenTabs.Logs} headerText="Sign-In Logs">
          <UserSignInLogs user={props.user} />
        </PivotItem>
        <PivotItem itemKey={UserScreenTabs.Security} headerText="Security">
          <UserSecurity user={props.user} />
        </PivotItem>
      </PivotTabs>
    </Stack>
  );
};
